// Age computation from a YYYY-MM-DD birthday string.
// Old MM-DD birthdays (no year) return null: age unknown.

export function computeAge(bday) {
  if (!bday || !/^\d{4}-\d{2}-\d{2}$/.test(bday)) return null;
  const [y, m, d] = bday.split('-').map(Number);
  const today = new Date();
  let age = today.getFullYear() - y;
  if (today.getMonth() + 1 < m || (today.getMonth() + 1 === m && today.getDate() < d)) {
    age -= 1;
  }
  return age >= 0 && age < 120 ? age : null;
}

export function formatAge(age, language) {
  if (age === null || age === undefined) return '';
  if (language === 'ru') {
    const mod10 = age % 10;
    const mod100 = age % 100;
    const word = (mod100 >= 11 && mod100 <= 14) ? 'лет' : mod10 === 1 ? 'год' : (mod10 >= 2 && mod10 <= 4) ? 'года' : 'лет';
    return `${age} ${word}`;
  }
  if (language === 'uk') {
    const mod10 = age % 10;
    const mod100 = age % 100;
    const word = (mod100 >= 11 && mod100 <= 14) ? 'років' : mod10 === 1 ? 'рік' : (mod10 >= 2 && mod10 <= 4) ? 'роки' : 'років';
    return `${age} ${word}`;
  }
  if (language === 'md') {
    return age < 20 ? `${age} ani` : `${age} de ani`;
  }
  return `${age} ans`;
}
